var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "url(#paint0_radial_8915_120514)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8915_120514)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7507 34.5448C70.315 34.4312 69.8605 34.3744 69.4059 34.3838H40.228C37.0081 34.3744 34.3943 36.9787 34.3848 40.1986C34.3848 40.208 34.3848 40.2175 34.3848 40.227V69.4428C34.3753 69.8974 34.4322 70.3519 34.5458 70.7876C34.9814 70.9012 35.436 70.958 35.8906 70.9486H36.9797C36.9797 70.9486 37.5763 66.1377 38.0687 62.1791C38.4381 59.2528 40.9288 57.0557 43.874 57.0651H56.943C59.8883 57.0651 62.3695 59.2622 62.7388 62.1791C63.2407 66.1377 63.8279 70.9486 63.8279 70.9486H65.0306C68.26 70.9391 70.8643 68.3253 70.8738 65.1054V35.8423C70.8832 35.4066 70.8359 34.971 70.7507 34.5448ZM50.4559 51.1746C46.4215 51.1746 43.1543 47.9074 43.1543 43.873C43.1543 39.8387 46.4215 36.5715 50.4559 36.5715C54.4902 36.5715 57.7574 39.8387 57.7574 43.873C57.748 47.9074 54.4807 51.1746 50.4559 51.1746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4548 52.2827C45.8144 52.2827 42.0547 48.523 42.0547 43.8826C42.0547 39.2421 45.8144 35.4824 50.4548 35.4824C55.0953 35.4824 58.8549 39.2421 58.8549 43.8826C58.8549 48.523 55.0953 52.2827 50.4548 52.2827ZM50.4548 37.6701C47.0266 37.6701 44.2423 40.4543 44.2423 43.8826C44.2423 47.3108 47.0266 50.0951 50.4548 50.0951C53.8831 50.0951 56.6673 47.3108 56.6673 43.8826C56.6484 40.4543 53.8736 37.6795 50.4548 37.6701Z",
    fill: "#A0B9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9645 30.9366C68.667 29.6297 66.9056 28.891 65.0683 28.9005H35.8336C32.0076 28.9005 28.9014 32.0067 28.9014 35.8327V65.058C28.9014 68.8934 32.0076 71.9902 35.8336 71.9902H65.0589C68.8943 71.9902 71.9911 68.884 71.9911 65.058V35.8327C72.01 33.9955 71.2714 32.234 69.9645 30.9366ZM38.3338 69.8026L39.2808 62.2737C39.5838 59.8967 41.601 58.1163 43.997 58.1163H57.066C59.4619 58.1163 61.4791 59.8967 61.7822 62.2737L62.7292 69.8026H38.3338ZM69.8698 65.0485C69.8698 67.6718 67.739 69.8026 65.1157 69.8026H64.8979L63.913 62.0086C63.4773 58.5424 60.5226 55.9381 57.0281 55.9381H43.9591C40.4267 55.8908 37.4151 58.5046 36.97 62.0086L36.0041 69.8026H35.8336C33.2103 69.8026 31.0795 67.6718 31.0795 65.0485V35.8327C31.089 33.2095 33.2103 31.0881 35.8336 31.0881H65.0589C67.6821 31.0881 69.8129 33.2189 69.8129 35.8422L69.8698 65.0485Z",
    fill: "#A0B9C1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0649 60.1299C80.6237 60.1299 85.1299 55.6237 85.1299 50.0649C85.1299 44.5062 80.6237 40 75.0649 40C69.5062 40 65 44.5062 65 50.0649C65 55.6237 69.5062 60.1299 75.0649 60.1299Z",
    fill: "#FDB022"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8915_120514",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 8.75) rotate(66.1979) scale(99.7328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8915_120514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.0992,
    height: 43.0992,
    fill: "white",
    transform: "translate(28.9004 28.9004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyAccount);
export default __webpack_public_path__ + "static/media/verifyAccount.05ae7fe3ba2e964413134d3265d5ddf3.svg";
export { ForwardRef as ReactComponent };